export default "__VITE_ASSET__CohCl5NM__"